import { BACKEND, img } from "../../lib/api";

export const videoSrc = (v) => (v.source === "upload" ? `${BACKEND}/api/video-files/${v.file_id}` : v.embed_url || `https://www.youtube-nocookie.com/embed/${v.youtube_id}`);

export function VideoPlayer({ v, title, autoplay = false }) {
  if (v.source === "upload")
    return <video className="w-full h-full bg-black" src={videoSrc(v)} poster={img(v.thumbnail)} controls preload="metadata" autoPlay={autoplay} playsInline data-testid="video-player" />;
  const sep = videoSrc(v).includes("?") ? "&" : "?";
  return (
    <iframe className="w-full h-full" src={`${videoSrc(v)}${sep}${autoplay ? "autoplay=1&" : ""}rel=0`} title={title} data-testid="video-player"
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen loading="lazy" />
  );
}
